import BellinatiPerezLogo from '../../assets/bellinati-perez.svg'

import styles from './styles.module.scss'

export function Header() {
  return (
    <header className={styles.header}>
      <img src={BellinatiPerezLogo} alt="Logo Bellinati" />
    </header>
  )
}